import styled from 'styled-components';
import {
  Modal as SemanticModal,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Modal = styled(SemanticModal)`
  ${({ showTab }) => !showTab && 'max-width: 680px'};
`;

export const Container = styled.div`
  display: flex;
  padding: 20px;
  width: 100%;
  flex-direction: column;
  align-content: stretch;
  height: 80vh;
`;

export const Title = styled(TextLayoutComponent.Header)`
  font-size: 16px;
`;

export const ContainerTitle = styled.div`
  padding-top: 9px;
  padding-left: ${({ spacetotabs, showTab }) => (spacetotabs && showTab ? '27.5%' : '20px')};
`;

export const ContainerItems = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex-grow: 1;
  overflow: auto;
`;

export const ContainerLeft = styled.div`
  display: flex;
  width: 25%;
  padding: 20px 0;
  flex-direction: column;
  min-width: 25%;
`;

export const Tab = styled.div`
  margin: 10px 0;
  padding: 10px;
  border-radius: 3px;
  width: fit-content;
  cursor: pointer;
  ${({ selected }) => selected && 'background-color: #E9F0FF'}
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 0   20px;
  flex-grow: 1;
  max-width: ${({ spacetotabs }) => (spacetotabs ? '75%' : '100%')};
`;
